// Boolean attribute. Persisted as the strings 'true' / 'false' by default, or
// as a real boolean where the consumer's API expects one.

import React from 'react';
import startCase from 'lodash/startCase';
import Checkbox from '@decisiv/ui-components/lib/components/Checkbox';

import { fieldPropTypes } from './fieldPropTypes';

const CheckboxInput = ({
  descriptor,
  label,
  value,
  warningMessage = '',
  readOnly = true,
  onChange,
  onBlur,
}) => (
  <Checkbox
    name={descriptor.name}
    label={startCase(label)}
    required={descriptor.required}
    warningMessage={warningMessage}
    disabled={readOnly}
    checked={value === true || value === 'true'}
    onChange={(e) => onChange(descriptor.name, e.target.checked)}
    onBlur={() => onBlur?.(descriptor.name)}
  />
);

CheckboxInput.propTypes = fieldPropTypes;

export default CheckboxInput;
